(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["carousel"] && !Shopify.designMode) return;
  try {
    class CarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.scrollContainer = this.querySelector('[data-track]');
    this.nav = this.querySelector('.b-carousel__nav');
    this.prevButton = this.querySelector('[data-previous]');
    this.nextButton = this.querySelector('[data-next]');
    this.slides = this.querySelectorAll('.shopify-block');
  }

  connectedCallback() {
    this.prevButton.addEventListener('click', () => this.slide('prev'));
    this.nextButton.addEventListener('click', () => this.slide('next'));
    this.scrollContainer.addEventListener('scroll', () => this.updateButtonStates());
    
    // Check initial state
    this.updateButtonStates();
    
    // Update on resize
    window.addEventListener('resize', () => this.updateButtonStates());
  }

  updateButtonStates() {
    const scrollLeft = this.scrollContainer.scrollLeft;
    const scrollWidth = this.scrollContainer.scrollWidth;
    const clientWidth = this.scrollContainer.clientWidth;
    const maxScroll = scrollWidth - clientWidth;
    
    // Check if content fits without scrolling
    if (scrollWidth <= clientWidth) {
      this.nav.classList.add('b-carousel__nav--hidden');
      return;
    } else {
      this.nav.classList.remove('b-carousel__nav--hidden');
    }
    
    // Check if at start
    if (scrollLeft <= 0) {
      this.prevButton.classList.add('b-carousel__arrow--disabled');
      this.prevButton.disabled = true;
    } else {
      this.prevButton.classList.remove('b-carousel__arrow--disabled');
      this.prevButton.disabled = false;
    }
    
    // Check if at end (with small threshold for rounding errors)
    if (scrollLeft >= maxScroll - 1) {
      this.nextButton.classList.add('b-carousel__arrow--disabled');
      this.nextButton.disabled = true;
    } else {
      this.nextButton.classList.remove('b-carousel__arrow--disabled');
      this.nextButton.disabled = false;
    }
  }

  slide(direction) {
    if ((direction === 'prev' && this.prevButton.disabled) || 
        (direction === 'next' && this.nextButton.disabled)) {
      return;
    }
    
    const slideWidth = this.slides[0].offsetWidth;
    const scrollAmount = direction === 'next' ? slideWidth : -slideWidth;
    const currentScroll = this.scrollContainer.scrollLeft;

    this.scrollContainer.scrollTo({
      left: currentScroll + scrollAmount + (direction === 'next' ? 16 : -16), // Account for gap
      behavior: 'smooth'
    });
  }

  disconnectedCallback() {
    this.prevButton.removeEventListener('click', () => this.slide('prev'));
    this.nextButton.removeEventListener('click', () => this.slide('next'));
    this.scrollContainer.removeEventListener('scroll', () => this.updateButtonStates());
    window.removeEventListener('resize', () => this.updateButtonStates());
  }
}

customElements.define('carousel-component', CarouselComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["closer-look"] && !Shopify.designMode) return;
  try {
    class CloserLook extends HTMLElement {

      constructor() {
        super();

        this.buttons = this.querySelectorAll('button');
        this.images = this.querySelectorAll('.b-closer-look__container');

        this.activeIndex = 0;

      }



      connectedCallback() {
        this.buttons.forEach(button => {
          button.addEventListener('click', this.toggleImage.bind(this));
        });

        this.render();
      }



      toggleImage(event) {
        const button = event.currentTarget;

        this.activeIndex = Array.from(this.buttons).indexOf(button);

        this.render();

      }


      render() {
        this.images.forEach((image, i) => {
          if (i === this.activeIndex) {
            this.toggleVisibility(image, true);
          } else {
            this.toggleVisibility(image, false);
          }
        });

        this.buttons.forEach((button, i) => {
          if (i === this.activeIndex) {
            this.toggleVisibility(button, false);
          } else {
            this.toggleVisibility(button, true);
          }
        });

      }


      toggleVisibility(element, show) {
        if (show) {
            element.classList.remove('hidden');
          } else {
            element.classList.add('hidden');
          }
      }


      disconnectedCallback() {
        this.buttons.forEach(button => {
          button.removeEventListener('click', this.toggleImage);
        });
      }

    }

    customElements.define('closer-look', CloserLook);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cycler"] && !Shopify.designMode) return;
  try {
    customElements.define('b-content-cycle', class ContentCycle extends HTMLElement {

  constructor() {
    super();
    this.contents = this.querySelectorAll('.b-cycler__content > .shopify-block');
    this.interval = null;
    this.activeIndex = 0;
    this.speed = parseInt(this.getAttribute('data-speed')) || 5000;
  }

  connectedCallback() {
    this.addEventListener('mouseover', this.focusInHandling);
    this.addEventListener('mouseleave', this.focusOutHandling);

    this.play();
  }

  disconnectedCallback() {
    this.stop();
    this.removeEventListener('mouseover', this.focusInHandling);
    this.removeEventListener('mouseleave', this.focusOutHandling);
  }

  play() {

    if (this.contents.length < 2) return;

    this.interval = setInterval(() => {
        const nextIndex = this.activeIndex === (this.contents.length-1) ? 0 : this.activeIndex + 1

        this.toggleVisibility(this.contents[this.activeIndex], false);
        this.toggleVisibility(this.contents[nextIndex], true);
        this.activeIndex = nextIndex;

    }, this.speed);
  }


  stop() {
      clearInterval(this.interval);
  }

  focusOutHandling(event) {
    this.play();
  }

  focusInHandling(event) {
      this.stop();
  }

  toggleVisibility(element, show) {
    element.style.display = show ? 'block' : 'none';
  }

});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-video-tutorials"] && !Shopify.designMode) return;
  try {
    class ProductVideoTutorials extends HTMLElement {
    constructor() {
      super();

      this.links = this.querySelectorAll("[data-tutorial-link]")
      this.tutorials = this.querySelectorAll("[data-tutorial]")

      this.active = this.tutorials[0]

    }


    connectedCallback() {
      this.links.forEach(element => {
        element.addEventListener('click', this.handleLink.bind(this))
      });
    }


    disconnectedCallback() {
      this.links.forEach(element => {
        element.removeEventListener('click', this.handleLink.bind(this))
      });
    }


    handleLink(event) {
      event.preventDefault();
      const link = event.currentTarget

      const index = Array.from(this.links).findIndex((el) => el == link)


      this.active.classList.add('lg:hidden')
      this.active = this.tutorials[index]
      this.active.classList.remove('lg:hidden')

    }



  }


  customElements.define('product-video-tutorials', ProductVideoTutorials);
  } catch(e) { console.error(e); }
})();

})();
